import type { SenderKey } from "../../../logic/invoice-sender";
import type { AssignedState } from "../../../components/AssignedStateToggle";

export type InvoiceSort = "dueDateDesc" | "receivedDateDesc" | "nameAsc";

export type Filters = {
  namePattern: string;
  /** Payees and accounts alike — see `invoiceSenderKey`. */
  senderKeys: SenderKey[];
  attachments: AssignedState;
  from: string | null;
  to: string | null;
};

export const defaultFilters: Filters = {
  namePattern: "",
  senderKeys: [],
  attachments: "any",
  from: null,
  to: null,
};

export const isDefaultFilters = (f: Filters): boolean =>
  f.namePattern === "" &&
  f.senderKeys.length === 0 &&
  f.attachments === "any" &&
  f.from === null &&
  f.to === null;
